import { Axios, setAuthToken } from "./config/Axios";

////// AUTHENTICATION //////
// Register User
export const registerUser = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/register-teacher", params);
  return response;
};

// Verify User
export const verifyAccount = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/verifyAccount", params);
  return response;
};

// Reset Password
export const resetPassword = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/forgot-password", params);
  return response;
}

// Login User
export const loginUser = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/login", params);
  return response;
};

export const getOtp = async (params) =>{
  setAuthToken();
  const response = await Axios.post("/auth/verify-otp", params);
  return response;
}

export const getUserProfile = async () =>{
  setAuthToken();
  const response = await Axios.get("/auth/profile");
  return response;
}

export const updateUserProfile = async (params) =>{
  setAuthToken(); 
  const response = await Axios.put("/auth/settings", params);
  return response;
}

export const getAllSchools = async () =>{
  setAuthToken();
  const response = await Axios.get("/auth/schools");
  return response;
}

export const deleteAccount = async () =>{
  setAuthToken();
  const response = await Axios.delete("/auth/delete-teacher");
  return response;
}



//PDFS

export const getAllPdfs = async (params) =>{
  setAuthToken();
  const response = await Axios.get("/pdf/getall",{params:params});
  return response;

}

export const markStudentsAsReviewed = async (filename) =>{
  setAuthToken();
  const response = await Axios.put("/pdf/mark-students-as-reviewed", {filename:filename});
  return response;
}

export const uploadPdf = async (params) =>{
  setAuthToken();
  const response = await Axios.post("/pdf/add", params);
  return response;
}

export const getStudentReport = async (params, queryParams) =>{
  setAuthToken();
  const response = await Axios.post("/pdf/report", params, {params:queryParams});
  return response;
}

export const getClassReport = async (params, queryParams) =>{
  setAuthToken();
  const response = await Axios.post("/pdf/class-summary", params, {params:queryParams});
  return response;
}

export const getQueAns = async (params) =>{
  setAuthToken();
  const response = await Axios.get("/pdf/que-ans", {params:params});
  return response;
}

export const reannotatePdf = async (id) => {
  setAuthToken();
  const response = await Axios.post("/pdf/reannotate", { id: Number(id) });
  return response;
}

export const getOneAns = async (params) =>{
  setAuthToken();
  const response = await Axios.get(`/pdf/que-ans/${params}`);
  return response;
}

// Validation Findings
export const getValidationFindings = async (id) => {
  setAuthToken();
  const response = await Axios.get(`/pdf/validation-findings/${id}`);
  return response;
}

export const proceedWithEvaluation = async (id) => {
  setAuthToken();
  const response = await Axios.post(`/pdf/proceed-evaluation/${id}`);
  return response;
}

export const cancelEvaluation = async (id) => {
  setAuthToken();
  const response = await Axios.post(`/pdf/cancel-evaluation/${id}`);
  return response;
}

export const retryEvaluation = async (id) => {
  setAuthToken();
  const response = await Axios.post(`/pdf/retry-evaluation/${id}`);
  return response;
}

export const updateaiEval = async(params) =>{
   setAuthToken();
  const response = await Axios.put(`/pdf/ai-eval`,params);
  return response;

}

export const updateFeedback = async(params) =>{
  setAuthToken();
  const response = await Axios.post(`/pdf/update-feedback`,params);
  return response;
}

export const sharePDF = async(params) =>{
  setAuthToken();
  const response = await Axios.post(`/pdf/share`,params);
  return response;
}

export const createPDFStudent = async(params) =>{
  setAuthToken();
  const response = await Axios.post(`/pdf/create-pdf-student`,params,{responseType: "blob"});
  return response;
}

export const createPDFFeedback = async(params) =>{
  setAuthToken();
  const response = await Axios.post(`/pdf/create-pdf-feedback`,params,{responseType: "blob"});
  return response;
}

/** Merged PDF: workflow marked answer sheet + feedback report (requires file_wf_marked on server). */
export const createPDFFeedbackWf = async (params) => {
  setAuthToken();
  const response = await Axios.post(
    `/pdf/create-pdf-feedback-wf`,
    params,
    { responseType: "blob" }
  );
  return response;
};

export const updateNotificationStatus = async(params) =>{
  setAuthToken();
  const response = await Axios.put(`/auth/update-notification-status`,params);
  return response;
}

//add teacher remarks
export const addTeacherRemarks = async(params) =>{
  setAuthToken();
  const response = await Axios.post(`/pdf/add-teacher-remarks`,params);
  return response;
}

//Admin Panel Requests
export const getOverviewStats = async() =>{
  setAuthToken();
  const response = await Axios.get("/pdf/overview");
  return response;
}

export const getAssignmentStats = async(params) =>{
  setAuthToken();
  const response = await Axios.get("/pdf/assignment",{params:params});
  return response;
}


export const exportClassSummary = async(params) =>{
  setAuthToken();
  const response = await Axios.get("/pdf/export-class-summary",{params:params});
  return response;
}

export const exportStudentDetails = async(params) =>{
  setAuthToken();
  const response = await Axios.get("/pdf/export-student-details",{params:params});
  return response;
}

export const putCMS = async(params) =>{
  setAuthToken();
  const response = await Axios.post("/auth/add-cms", params);
  return response;
}

export const getCMS = async(params) =>{
  setAuthToken();
  const response = await Axios.get("/auth/get-cms", {params:params});
  return response;
}

export const downloadReport = async(params) =>{
  setAuthToken();
  const response = await Axios.post("/pdf/create-pdf",params,{responseType: "blob"});
  return response;
}

export const createExcel = async(params) =>{
  setAuthToken();
  const response = await Axios.post("/pdf/create-excel",params,{responseType: "blob"});
  return response;
}






//Notifications
export const getNotifications = async () => {
  setAuthToken();
  const response = await Axios.get("/notifications/my-notifications");
  return response;
};

export const getAllNotifications = async (params) => {
  setAuthToken();
  const response = await Axios.get("/notifications/all-notifications", {params:params});
  return response;
};

export const sendNotification = async (params) => {
  setAuthToken();
  const response = await Axios.post("/notifications/add-notification", params);
  return response;
};


export const getUnreadNotifications = async () => {
  setAuthToken();
  const response = await Axios.get("/notifications/unread-notifications");
  return response;
};

export const markNotificationAsRead = async (params) => {
  setAuthToken();
  const response = await Axios.post("/notifications/mark-read", params);
  return response;
};





export const markNotificationsAsRead = async (params) => {
  setAuthToken();
  const response = await Axios.get("/notifications/mark-read");
  return response;
};

//Admin Requests
// Add Teacher
export const addTeacher = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/register-teacher-admin", params);
  return response;
};

// Get Teacher List
export const getTeacherList = async (queryParams) => {
  setAuthToken();
  const response = await Axios.get("/auth/get-all-teachers",{params:queryParams});
  return response;
};

// Update Teacher
export const updateTeacher = async (id,params) => {
  setAuthToken();
  const response = await Axios.put(`/auth/update-teacher/${id}`, params);
  return response;
};

// Block Teacher
export const blockTeacher = async (id,params) => {
  setAuthToken();
  const response = await Axios.put(`/auth/block-teacher/${id}`, params);
  return response;
};

// PLANS ROUTES

export const getPlans = async () => {
  setAuthToken();
  const response = await Axios.get("/plans/get-plans");
  return response;
}

export const getModules = async () => {
  setAuthToken();
  const response = await Axios.get("/plans/get-modules");
  return response;
}

export const getPlanModules = async (planId) => {
  setAuthToken();
  const response = await Axios.get(`/plans/get-plan-modules`);
  return response;
}

export const updateTeacherPlan = async (params) => {
  setAuthToken();
  const response = await Axios.post(`/plans/update-teacher-plan`, params);
  return response;
}

export const createPlan = async (params) => {
  setAuthToken();
  const response = await Axios.post("/plans/create-plan", params);
  return response;
}

export const updatePlan = async (params) => {
  setAuthToken();
  const response = await Axios.put("/plans/update-plan", params);
  return response;
}

export const deletePlan = async (planId) => {
  setAuthToken();
  const response = await Axios.delete(`/plans/delete-plan/${planId}`);
  return response;
}



////// AUTHENTICATION //////

////// PRIVATE REQUESTS //////
// Get user Info
export const getUserInfo = async () => {
  setAuthToken();
  const response = await Axios.get("/admin/user-info");
  return response;
};


//dwld excel
export const downloadExcel = async (params) =>{
  setAuthToken();
  const response = await Axios.post("/pdf/get-class-report-excel", params,{responseType: "blob"});
  return response;
}



//google login 
export const googleLogin = async (params) => {
  setAuthToken();
  const response = await Axios.post("/auth/google", params);
  return response;
}



//school management 

export const getAllSchoolsAdmin = async (queryParams) =>{
  setAuthToken();
  const response = await Axios.get("/admin/get-all-schools",{params:queryParams});
  return response;
}

export const getAllTeachersAdmin = async (queryParams) =>{
  setAuthToken();
  const response = await Axios.get("/admin/get-all-teachers",{params:queryParams});
  return response;
}

export const getAllPapersAdmin = async (queryParams) =>{
  setAuthToken();
  const response = await Axios.get("/admin/get-all-papers",{params:queryParams});
  return response;
}

export const addExcelTeachers = async (params) =>{
  setAuthToken();
  const response = await Axios.post("/admin/add/excel", params);
  return response;
}

export const addSchool = async (params) =>{
  setAuthToken();
  const response = await Axios.post("/admin/add-school", params);
  return response;
}

export const editSchool = async (params) =>{
  setAuthToken();
  const response = await Axios.put(`/admin/edit-school`, params);
  return response;
}

export const getSchoolCodes = async () =>{
  setAuthToken();
  const response = await Axios.get("/admin/get-schools");
  return response;
}


//user routes
export const updateStudent = async (params) =>{
  setAuthToken();
  const response = await Axios.put("/auth/update-student", params);
  return response;
}


//subscriptions

export const getAllSubscriptions = async (queryParams) =>{
  setAuthToken();
  const response = await Axios.get("/admin/get-all-subscriptions",{params:queryParams});
  return response;
}

export const updateTeacherSubscription = async (params) =>{
  setAuthToken();
  const response = await Axios.put("/admin/update-teacher-plan", params);
  return response;
}

export const getUsageSubscriptions = async (queryParams) =>{
  setAuthToken();
  const response = await Axios.get("/admin/get-usage",{params:queryParams});
  return response;
}

export const getAllPlans = async () =>{
  setAuthToken();
  const response = await Axios.get("/auth/get-all-plans");
  return response;
}

// review accuracy tracking
export const getQuestionStatsBySubject = async (queryParams) => {
  setAuthToken();
  const response = await Axios.get("/admin/question-stats-by-subject", {
    params: queryParams,
  });
  return response;
};


// payments routes
export const createCheckout = async (params) =>{
  setAuthToken();
  const response = await Axios.post("/payments/create-checkout", params);
  return response;
}

export const createAddonCheckout = async (params) =>{
  setAuthToken();
  const response = await Axios.post("/payments/create-checkout/addon", params);
  return response;
}

export const verifyPayment = async (params) =>{
  setAuthToken();
  const response = await Axios.get("/payments/verify-payment", {params:params});
  return response;
}

export const cancelSubscription = async () =>{
  setAuthToken();
  const response = await Axios.get("/payments/cancel-subscription");
  return response;
}


//contact us
export const contactUs = async (params) =>{
  setAuthToken();
  const response = await Axios.post("/auth/contact-us", params);
  return response;
}


//addons routes
export const getAddons = async () =>{
  setAuthToken();
  const response = await Axios.get("/addons/get-addons");
  return response;
}

// admin route for addons
export const getAddonsAdmin = async () =>{
  setAuthToken();
  const response = await Axios.get("/plans/get-addons");
  return response;
}

// admin create addons plans
export const createAddonsPlan = async (params) =>{
  setAuthToken();
  const response = await Axios.post("/plans/create-addon-plan", params);
  return response;
}

// admin update addons plans
export const updateAddonsPlan = async (params) =>{
  setAuthToken();
  const response = await Axios.put("/plans/update-addon-plan", params);
  return response;
}


// group by grade and exam
export const groupByGradeAndExam = async (queryParams) =>{
  setAuthToken();
  const response = await Axios.get("/pdf/group-by-grade-and-exam", {params:queryParams});
  return response;
}
